/**
 * @generated SignedSource<<a5a26887de43f86c37eea811f2e7be84>>
 * @relayHash a5eca063ad29243565328e156e2cec22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28685f8ed3a81c39e524cd202fdbe2ebcf3caad6e330eebf0196b4d2a6472b75

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiErrorMessageTemplate = "A2A_ERROR" | "ACCEPTABLE_USE_VIOLATIONS" | "ERROR" | "PRE_EXECUTION_ERROR" | "%future added value";
export type ConvoAiMessageAuthorRole = "AGENT" | "ASSISTANT" | "HUMAN" | "%future added value";
export type useCommentAgentSessionStatusSubscription$variables = {
  cloudId: string;
  conversationId: string;
};
export type useCommentAgentSessionStatusSubscription$data = {
  readonly convoai_onAgentSessionUpdate: {
    readonly __typename: "ConvoAiConversationMessage";
    readonly actions: ReadonlyArray<{
      readonly key: string;
    } | null> | null;
    readonly role: ConvoAiMessageAuthorRole;
  } | {
    readonly __typename: "ConvoAiErrorMessage";
    readonly errorMessageTemplate: ConvoAiErrorMessageTemplate;
  } | {
    readonly __typename: "ConvoAiTraceMessage";
    readonly messageTemplate: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useCommentAgentSessionStatusSubscription = {
  response: useCommentAgentSessionStatusSubscription$data;
  variables: useCommentAgentSessionStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "kind": "LinkedField",
    "name": "convoai_onAgentSessionUpdate",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "messageTemplate"
          }
        ],
        "type": "ConvoAiTraceMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "role"
          },
          {
            "concreteType": "ConvoAiAgentAction",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ],
        "type": "ConvoAiConversationMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": "errorMessageTemplate",
            "kind": "ScalarField",
            "name": "messageTemplate"
          }
        ],
        "type": "ConvoAiErrorMessage"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5eca063ad29243565328e156e2cec22",
    "id": "28685f8ed3a81c39e524cd202fdbe2ebcf3caad6e330eebf0196b4d2a6472b75",
    "metadata": {},
    "name": "useCommentAgentSessionStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription useCommentAgentSessionStatusSubscription($cloudId:ID!,$conversationId:ID!){convoai_onAgentSessionUpdate(cloudId:$cloudId,conversationId:$conversationId)@optIn(to:\"ConvoAiAgentSessionUpdate\"){__typename,...on ConvoAiTraceMessage{messageTemplate},...on ConvoAiConversationMessage{role,actions{key}},...on ConvoAiErrorMessage{errorMessageTemplate:messageTemplate}}}"
  }
};
})();

(node as any).hash = "3ac36cfd8a0cf83161bbc8f3293a6bbb";

export default node;
